(function ($) {
	'use strict';

	var attributionStorageKey = 'dd_beratung_attribution_v1';
	var attributionLifetime = 90 * 24 * 60 * 60 * 1000;
	var attributionKeys = [
		'utm_source',
		'utm_medium',
		'utm_campaign',
		'utm_term',
		'utm_content',
		'gclid',
		'fbclid'
	];

	function getStoredAttribution() {
		try {
			var stored = window.localStorage.getItem(attributionStorageKey);
			var attribution = stored ? JSON.parse(stored) : null;

			if (!attribution || !attribution.expiresAt || attribution.expiresAt < Date.now()) {
				window.localStorage.removeItem(attributionStorageKey);
				return null;
			}

			return attribution;
		} catch (error) {
			return null;
		}
	}

	function storeAttribution(attribution) {
		try {
			window.localStorage.setItem(attributionStorageKey, JSON.stringify(attribution));
		} catch (error) {
			// Attribution must never prevent the form from working.
		}
	}

	function getQueryParameter(parameterName) {
		var searchParams;

		try {
			searchParams = new window.URLSearchParams(window.location.search);
			return searchParams.get(parameterName) || '';
		} catch (error) {
			return '';
		}
	}

	function getCurrentTouch() {
		var touch = {
			landing_page: window.location.href,
			referrer: document.referrer || '',
			captured_at: new Date().toISOString()
		};
		var hasCampaignData = false;

		$.each(attributionKeys, function (_, key) {
			var value = getQueryParameter(key);
			touch[key] = value.substring(0, 255);
			hasCampaignData = hasCampaignData || value !== '';
		});

		touch.has_campaign_data = hasCampaignData;
		return touch;
	}

	function captureAttribution() {
		var stored = getStoredAttribution();
		var currentTouch = getCurrentTouch();

		if (!stored) {
			stored = {
				first: currentTouch,
				last: currentTouch,
				expiresAt: Date.now() + attributionLifetime
			};
			storeAttribution(stored);
			return stored;
		}

		if (currentTouch.has_campaign_data) {
			stored.last = currentTouch;
			stored.expiresAt = Date.now() + attributionLifetime;
			storeAttribution(stored);
		}

		return stored;
	}

	function populateAttributionFields($form, attribution) {
		if (!attribution) {
			return;
		}

		$.each(['first', 'last'], function (_, touchType) {
			var touch = attribution[touchType] || {};
			var fields = attributionKeys.concat(['landing_page', 'referrer', 'captured_at']);

			$.each(fields, function (__, fieldName) {
				$('<input>', {
					type: 'hidden',
					name: touchType + '_' + fieldName,
					value: touch[fieldName] || ''
				}).appendTo($form);
			});
		});
	}

	$(function () {
		var attribution = captureAttribution();

		$('[data-beratung-flow]').each(function () {
			var $flow = $(this);
			var $form = $flow.find('[data-beratung-form]');
			var $steps = $form.find('[data-beratung-step]');
			var $stepper = $flow.find('.beratung-stepper');
			var $stepperItems = $stepper.find('[data-stepper-item]');
			var $stepTabs = $stepper.find('[data-step-tab]');
			var $success = $flow.find('[data-success-state]');
			var $indicator = $form.find('[data-step-indicator]');
			var $next = $form.find('[data-step-next]');
			var $submit = $form.find('[data-step-submit]');
			var $back = $form.find('[data-step-back]');
			var $error = $form.find('[data-form-error]');
			var ajaxUrl = $flow.attr('data-ajax-url');
			var nonce = $flow.attr('data-nonce');
			var currentStep = 0;
			var maxVisited = 0;
			var submitLabel = $submit.html();

			populateAttributionFields($form, attribution);

			function clearError() {
				$error.prop('hidden', true).text('');
			}

			function showError(message) {
				$error.text(message).prop('hidden', false);
			}

			function clearFieldError($field) {
				$field.removeClass('is-invalid');
				$field.find('input, textarea').attr('aria-invalid', 'false');
				$field.find('[data-field-error]').prop('hidden', true);
			}

			function fieldErrorMessage(field) {
				if (field.validity.typeMismatch) {
					return 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
				}

				if (field.type === 'checkbox') {
					return 'Bitte bestätigen Sie die Datenschutzerklärung.';
				}

				return 'Bitte füllen Sie dieses Feld aus.';
			}

			function showFieldError($input) {
				var $field = $input.closest('.beratung-field');
				$field.addClass('is-invalid');
				$input.attr('aria-invalid', 'true');
				$field.find('[data-field-error]').first().text(fieldErrorMessage($input.get(0))).prop('hidden', false);
			}

			function validateStep() {
				var $current = $steps.eq(currentStep);
				var type = $current.attr('data-step-type');
				var valid = true;

				clearError();

				if (type === 'contact') {
					$current.find('.beratung-field').each(function () {
						clearFieldError($(this));
					});

					$current.find('input[required], textarea[required]').each(function () {
						if (!this.checkValidity()) {
							valid = false;
							showFieldError($(this));
						}
					});

					return valid;
				}

				if (type === 'checkbox') {
					if (!$current.find('input[type="checkbox"]:checked').length) {
						showError('Bitte wählen Sie mindestens einen Wunsch aus, um fortzufahren.');
						return false;
					}

					return true;
				}

				if (!$current.find('input[type="radio"]:checked').length) {
					showError('Bitte wählen Sie eine Option aus, um fortzufahren.');
					return false;
				}

				return true;
			}

			function updateStepChrome() {
				var isLast = currentStep === $steps.length - 1;

				$indicator.text('Schritt ' + (currentStep + 1) + ' von ' + $steps.length);
				$back.prop('hidden', currentStep === 0);
				$next.prop('hidden', isLast);
				$submit.prop('hidden', !isLast);

				$stepperItems.each(function (index) {
					var $item = $(this);
					var $button = $item.find('[data-step-tab]');
					var isActive = index === currentStep;

					$item.toggleClass('is-active', isActive);
					$item.toggleClass('is-complete', index < maxVisited && !isActive);
					$button.prop('disabled', index > maxVisited);

					if (isActive) {
						$button.attr('aria-current', 'step');
					} else {
						$button.removeAttr('aria-current');
					}
				});
			}

			function scrollToFlow() {
				var headerHeight = $('.site-header').outerHeight() || 0;
				var targetTop = Math.max(0, $flow.offset().top - headerHeight - 20);
				var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

				window.scrollTo({
					top: targetTop,
					behavior: reducedMotion ? 'auto' : 'smooth'
				});
			}

			function activateStep(index, shouldScroll) {
				if (index < 0 || index >= $steps.length) {
					return;
				}

				currentStep = index;
				maxVisited = Math.max(maxVisited, currentStep);

				$steps.each(function (stepIndex) {
					var isActive = stepIndex === currentStep;
					$(this).toggleClass('is-active', isActive).prop('hidden', !isActive);
				});

				clearError();
				updateStepChrome();

				if (shouldScroll) {
					scrollToFlow();
				}

				window.setTimeout(function () {
					$steps.eq(currentStep).find('legend').first().attr('tabindex', '-1').trigger('focus');
				}, 50);
			}

			function getPayload() {
				var data = $form.serializeArray();
				data.push({ name: 'action', value: 'dd_submit_beratung_form' });
				data.push({ name: 'nonce', value: nonce });

				return data;
			}

			function showSuccess() {
				$form.prop('hidden', true);
				$stepper.prop('hidden', true);
				$success.prop('hidden', false);
				scrollToFlow();
				$success.find('h2').attr('tabindex', '-1').trigger('focus');
			}

			$form.on('input change', 'input, textarea', function () {
				var $field = $(this).closest('.beratung-field');
				clearError();

				if ($field.hasClass('is-invalid') && this.checkValidity()) {
					clearFieldError($field);
				}
			});

			$next.on('click', function () {
				if (validateStep()) {
					activateStep(currentStep + 1, true);
				}
			});

			$back.on('click', function () {
				activateStep(currentStep - 1, true);
			});

			$stepTabs.on('click', function () {
				var stepIndex = parseInt($(this).attr('data-step-tab'), 10);

				if (!Number.isNaN(stepIndex) && stepIndex <= maxVisited) {
					activateStep(stepIndex, true);
				}
			});

			$form.on('submit', function (event) {
				event.preventDefault();

				if (!validateStep()) {
					return;
				}

				$submit.prop('disabled', true).text('Wird gesendet …');
				clearError();

				$.post(ajaxUrl, getPayload())
					.done(function (response) {
						if (response && response.success) {
							showSuccess();
							return;
						}

						showError(response && response.data && response.data.message ? response.data.message : 'Beim Senden ist ein Fehler aufgetreten.');
					})
					.fail(function (xhr) {
						var response = xhr.responseJSON;
						showError(response && response.data && response.data.message ? response.data.message : 'Die Anfrage konnte gerade nicht gesendet werden. Bitte versuchen Sie es erneut.');
					})
					.always(function () {
						$submit.prop('disabled', false).html(submitLabel);
					});
			});

			activateStep(0, false);
		});
	});
})(jQuery);
